module.exports = __webpack_public_path__ + "static/img/2.2ee696e.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting824/images/2.png
// module id = 0LEa
// module chunks = 4